<app-homebanner></app-homebanner>
<app-lobby-game-group [allGamesPage]="false"></app-lobby-game-group>
<div class="main_wrapper--row">
    <app-seo-content></app-seo-content>
</div>